import { createSlotsContext } from '@grandvisionhq/slots';

const [SubscriptionAddressFormSlotsProvider, useSubscriptionAddressFormSlots] = createSlotsContext({
    displayName: 'SubscriptionAddressFormSlotsContext'
});

export { SubscriptionAddressFormSlotsProvider, useSubscriptionAddressFormSlots };
//# sourceMappingURL=SubscriptionAddressFormSlotsContext.js.map
